package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2026_09_12_Day_3() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The heroes visit an altar to Entor and talk to a projection of Lalia. She confirms that the Dwarves of Ladikor have locked themselves in, and she warns of dangers deep inside the mountains. She confirms that Lord Pent has left Dorvid and returned to his ancestral home in Pentish, and she suggests that some of the remaining shards of the Shield of Concar may have moved.")
    }
}
